module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_1_m2.3e1826577e69a85b16d07d70984605b2.png";